import { render, staticRenderFns } from "./ProductFavouriteView.vue?vue&type=template&id=f684b9e2&scoped=true"
import script from "./ProductFavouriteView.vue?vue&type=script&lang=js"
export * from "./ProductFavouriteView.vue?vue&type=script&lang=js"
import style0 from "./ProductFavouriteView.vue?vue&type=style&index=0&id=f684b9e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f684b9e2",
  null
  
)

export default component.exports